import React, { useContext, useState } from 'react';
import { EDITOR_VIEW_TAB_INDEX } from '../../constants';

const TabsContext = React.createContext({});

const TabsContextProvider = TabsContext.Provider;

const TabsContextConsumer = TabsContext.Consumer;

const useTabsContext = () => useContext(TabsContext);

const TabsContextWrapper = ({
  withCredentials,
  children,
  disableBillingAddressUpdates,
  logoutGuestUsersOnComplete = true
}) => {
  const currentTabId = EDITOR_VIEW_TAB_INDEX;
  const [activeAccordions, setActiveAccordions] = useState([]);

  return (
    <TabsContextProvider
      value={{
        currentTabId,
        activeAccordions,
        setActiveAccordions
      }}>
      {children}
    </TabsContextProvider>
  );
};

export {
  TabsContext,
  TabsContextProvider,
  TabsContextConsumer,
  useTabsContext,
  TabsContextWrapper
};
